import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { alertsReducer, allergensReducer, announcementsReducer, checkoutReducer, completedOrdersReducer, configReducer, confirmationReducer, customerReducer, dealsReducer, donationsReducer, geolocationReducer, giftCardsReducer, groupOrderReducer, guestReducer, loaderReducer, menuDisplayReducer, menuItemsReducer, menuReducer, miscReducer, modalReducer, navReducer, navSiteReducer, notificationsReducer, oneTimePasscodeReducer, orderFulfillmentReducer, orderRatingReducer, orderReducer, postsReducer, pushNotificationsReducer, qrReducer, quoteReducer, resetPasswordReducer, revenueCentersReducer, rewardCodeReducer, sidebarModalReducer, sidebarReducer, signUpReducer, tagsReducer, termsReducer, unsubscribeReducer, validTimesReducer, verifyAccountReducer } from '../slices';
import { ReducerType } from '../slices/types';
export const appReducer = combineReducers({
    [ReducerType.Alerts]: alertsReducer,
    [ReducerType.Allergens]: allergensReducer,
    [ReducerType.Announcements]: announcementsReducer,
    [ReducerType.Checkout]: checkoutReducer,
    [ReducerType.CompletedOrders]: completedOrdersReducer,
    [ReducerType.Config]: configReducer,
    [ReducerType.Confirmation]: confirmationReducer,
    [ReducerType.Customer]: customerReducer,
    [ReducerType.Deals]: dealsReducer,
    [ReducerType.Donations]: donationsReducer,
    [ReducerType.Geolocation]: geolocationReducer,
    [ReducerType.GiftCards]: giftCardsReducer,
    [ReducerType.GroupOrder]: groupOrderReducer,
    [ReducerType.Guest]: guestReducer,
    [ReducerType.Loader]: loaderReducer,
    [ReducerType.Menu]: menuReducer,
    [ReducerType.MenuDisplay]: menuDisplayReducer,
    [ReducerType.MenuItems]: menuItemsReducer,
    [ReducerType.Modal]: modalReducer,
    [ReducerType.Misc]: miscReducer,
    [ReducerType.Nav]: navReducer,
    [ReducerType.NavSite]: navSiteReducer,
    [ReducerType.Notifications]: notificationsReducer,
    [ReducerType.OneTimePasscode]: oneTimePasscodeReducer,
    [ReducerType.Order]: orderReducer,
    [ReducerType.OrderFulfillment]: orderFulfillmentReducer,
    [ReducerType.OrderRating]: orderRatingReducer,
    [ReducerType.Posts]: postsReducer,
    [ReducerType.PushNotifications]: pushNotificationsReducer,
    [ReducerType.Qr]: qrReducer,
    [ReducerType.Quote]: quoteReducer,
    [ReducerType.ResetPassword]: resetPasswordReducer,
    [ReducerType.RevenueCenters]: revenueCentersReducer,
    [ReducerType.RewardCode]: rewardCodeReducer,
    [ReducerType.Sidebar]: sidebarReducer,
    [ReducerType.SidebarModal]: sidebarModalReducer,
    [ReducerType.SignUp]: signUpReducer,
    [ReducerType.Tags]: tagsReducer,
    [ReducerType.Terms]: termsReducer,
    [ReducerType.Unsubscribe]: unsubscribeReducer,
    [ReducerType.ValidTimes]: validTimesReducer,
    [ReducerType.VerifyAccount]: verifyAccountReducer
});
const rootReducer = (state, action) => {
    if (action.type === 'clearState') {
        // clearState()
        state = undefined;
    }
    return appReducer(state, action);
};
// const persistedState = loadState()
const store = configureStore({
    reducer: rootReducer,
    // preloadedState: persistedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false
    })
});
